var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _path13, _ellipse, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaticPdpDeliveryToday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 48,
    viewBox: "0 0 116 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 46.4068H33.987C30.4043 46.4068 27.5 43.5025 27.5 39.9199V39.9199C27.5 36.3372 30.4043 33.4329 33.987 33.4329H46.2635C49.984 33.4329 53 30.4169 53 26.6964V26.6964C53 22.976 49.984 19.96 46.2635 19.96H11.5",
    stroke: "#9C9D9E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.678 19.7581H82.415V39.1795H64.8232V30.4379L66.8749 23.3613C67.4933 21.2272 69.4519 19.7581 71.678 19.7581Z",
    fill: "#FF7058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.392 30.3498L69.2205 24.0417C69.5357 22.9574 70.5464 22.1985 71.6784 22.1985H79.9717V30.3498H67.392Z",
    fill: "#84DBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3894 30.3439H79.9756V22.1926L67.3894 30.3439Z",
    fill: "#CDD6E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.392 30.3498L69.2205 24.0417C69.5357 22.9574 70.5464 22.1985 71.6784 22.1985H79.9717L67.392 30.3498Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.75 10.0081H85.6649C83.8711 10.0081 82.4152 11.4599 82.4152 13.2513V39.1786H116V13.2513C116 11.46 114.545 10.0081 112.75 10.0081Z",
    fill: "#FFD15C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9995 39.1765V42.8413H115.995V39.1765H110.568C109.301 36.9062 106.863 35.3711 104.069 35.3711C101.285 35.3711 98.8474 36.9062 97.5692 39.1765H80.1073C78.8399 36.9062 76.4145 35.3711 73.6197 35.3711C70.825 35.3711 68.3985 36.9062 67.1203 39.1765H63.9995Z",
    fill: "#253A56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4301 42.8195C68.4301 45.6801 70.7537 47.9989 73.6199 47.9989C76.4862 47.9989 78.8076 45.6801 78.8076 42.8195C78.8076 39.959 76.4852 37.6401 73.6199 37.6401C70.7526 37.6401 68.4301 39.959 68.4301 42.8195Z",
    fill: "#40596B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5336 42.8193C71.5336 43.9685 72.4674 44.8993 73.6178 44.8993C74.7693 44.8993 75.7041 43.9685 75.7041 42.8193C75.7041 41.6701 74.7703 40.7393 73.6178 40.7393C72.4674 40.7382 71.5336 41.6702 71.5336 42.8193Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8831 42.8195C98.8831 45.6801 101.208 47.9989 104.073 47.9989C106.939 47.9989 109.263 45.6801 109.263 42.8195C109.263 39.959 106.939 37.6401 104.073 37.6401C101.208 37.6401 98.8831 39.959 98.8831 42.8195Z",
    fill: "#40596B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.989 42.8193C101.989 43.9685 102.921 44.8993 104.073 44.8993C105.225 44.8993 106.158 43.9685 106.158 42.8193C106.158 41.6701 105.224 40.7393 104.073 40.7393C102.922 40.7393 101.989 41.6702 101.989 42.8193Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5511 5.9873C96.9288 5.9873 94.5106 6.85938 92.5718 8.32882C89.794 10.4341 88.7891 17.5149 88.7891 17.5149L104.39 27.9851C108.353 26.158 111.102 22.1569 111.102 17.5149C111.102 11.1483 105.93 5.9873 99.5511 5.9873Z",
    fill: "#666666"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14520_43879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.251 16.7354C109.892 11.476 105.603 7.19557 100.333 6.83729C97.6559 6.65524 95.1714 7.45734 93.2063 8.91694C92.7884 9.22734 92.25 8.71429 92.564 8.29941L92.5845 8.27069C89.5253 10.5903 87.6546 14.3945 88.0533 18.6072C88.5701 24.0677 92.9858 28.4745 98.4573 28.9903C102.678 29.3882 106.487 27.5222 108.812 24.4691C107.952 25.1209 106.995 25.6474 105.971 26.0415C108.769 23.9586 110.511 20.5421 110.251 16.7354Z",
    fill: "#333333"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5406 27.2509C104.934 27.2509 109.306 22.8876 109.306 17.5052C109.306 12.1228 104.934 7.75952 99.5406 7.75952C94.1474 7.75952 89.7754 12.1228 89.7754 17.5052C89.7754 22.8876 94.1474 27.2509 99.5406 27.2509Z",
    fill: "#D7DEE0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5502,
    cy: 17.5166,
    rx: 9.07556,
    ry: 9.05737,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5406 25.4815C99.2952 25.4815 99.0967 25.2832 99.0967 25.0386V24.5956C99.0967 24.351 99.2952 24.1526 99.5406 24.1526C99.7859 24.1526 99.9844 24.351 99.9844 24.5956V25.0386C99.9845 25.2832 99.7859 25.4815 99.5406 25.4815Z",
    fill: "#9C9D9E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5406 10.8626C99.2952 10.8626 99.0967 10.6643 99.0967 10.4197V9.97667C99.0967 9.73206 99.2952 9.53369 99.5406 9.53369C99.7859 9.53369 99.9844 9.73206 99.9844 9.97667V10.4197C99.9845 10.6643 99.7859 10.8626 99.5406 10.8626Z",
    fill: "#9C9D9E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5508 17.5038C91.5508 17.2589 91.7496 17.0608 91.9947 17.0608H92.4385C92.6836 17.0608 92.8824 17.2589 92.8824 17.5038C92.8824 17.7487 92.6836 17.9468 92.4385 17.9468H91.9947C91.7496 17.9468 91.5508 17.7486 91.5508 17.5038Z",
    fill: "#9C9D9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.198 17.5038C106.198 17.2589 106.397 17.0608 106.642 17.0608H107.086C107.331 17.0608 107.53 17.2589 107.53 17.5038C107.53 17.7487 107.331 17.9468 107.086 17.9468H106.642C106.397 17.9468 106.198 17.7486 106.198 17.5038Z",
    fill: "#9C9D9E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.535 10.6029C103.748 10.7253 103.82 10.9962 103.698 11.2081L103.476 11.5917C103.353 11.8036 103.082 11.8763 102.87 11.7539C102.657 11.6315 102.584 11.3606 102.707 11.1487L102.929 10.7651C103.052 10.5532 103.323 10.4805 103.535 10.6029Z",
    fill: "#CED0D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2111 23.2611C96.4236 23.3835 96.4961 23.6544 96.3736 23.8663L96.1517 24.2499C96.0291 24.4618 95.7578 24.5345 95.5453 24.4121C95.3328 24.2897 95.2603 24.0188 95.3828 23.8069L95.6047 23.4233C95.7273 23.2114 95.9986 23.1387 96.2111 23.2611Z",
    fill: "#CED0D0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7734 14.1808C93.6507 14.3928 93.3793 14.4652 93.167 14.3429L92.7826 14.1214C92.5703 13.9991 92.4975 13.7283 92.6201 13.5163C92.7428 13.3042 93.0142 13.2318 93.2265 13.3541L93.6109 13.5756C93.8232 13.698 93.896 13.9687 93.7734 14.1808Z",
    fill: "#CED0D0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.159 21.1605C105.282 20.9485 105.553 20.8761 105.766 20.9984L106.15 21.2199C106.362 21.3422 106.435 21.613 106.313 21.825C106.19 22.0371 105.918 22.1095 105.706 21.9872L105.322 21.7657C105.109 21.6433 105.037 21.3726 105.159 21.1605Z",
    fill: "#CED0D0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5453 10.6029C95.3328 10.7253 95.2603 10.9962 95.3828 11.2081L95.6047 11.5917C95.7273 11.8036 95.9986 11.8763 96.2111 11.7539C96.4236 11.6315 96.4961 11.3606 96.3736 11.1487L96.1517 10.7651C96.0291 10.5532 95.7578 10.4805 95.5453 10.6029Z",
    fill: "#CED0D0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.458 24.6761C103.67 24.5537 103.743 24.2829 103.62 24.071L103.398 23.6873C103.276 23.4755 103.004 23.4028 102.792 23.5252C102.579 23.6476 102.507 23.9184 102.629 24.1303L102.851 24.514C102.974 24.7259 103.245 24.7985 103.458 24.6761Z",
    fill: "#CED0D0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6201 21.4913C92.7428 21.7034 93.0142 21.7758 93.2265 21.6535L93.6109 21.432C93.8232 21.3097 93.8961 21.0389 93.7734 20.8268C93.6507 20.6148 93.3794 20.5424 93.167 20.6647L92.7826 20.8862C92.5703 21.0085 92.4975 21.2793 92.6201 21.4913Z",
    fill: "#CED0D0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M105.306 14.1808C105.428 14.3928 105.7 14.4652 105.912 14.3429L106.296 14.1214C106.509 13.9991 106.582 13.7283 106.459 13.5163C106.336 13.3042 106.065 13.2318 105.853 13.3541L105.468 13.5756C105.256 13.698 105.183 13.9687 105.306 14.1808Z",
    fill: "#CED0D0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2651 18.1407C99.1466 17.9237 99.223 17.6521 99.4372 17.5287C99.659 17.4009 99.9428 17.4807 100.065 17.7053L101.857 20.9858C101.976 21.2027 101.899 21.4743 101.685 21.5978C101.463 21.7255 101.18 21.6458 101.057 21.4211L99.2651 18.1407Z",
    fill: "#2962FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0898 11.907C99.0898 11.6552 99.2939 11.4512 99.5456 11.4512C99.7974 11.4512 100.001 11.6552 100.001 11.907L100.001 16.7832C100.001 17.0349 99.7974 17.239 99.5456 17.239C99.2939 17.239 99.0898 17.0349 99.0898 16.7832L99.0898 11.907Z",
    fill: "#2962FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5406 18.8359C100.276 18.8359 100.872 18.2409 100.872 17.5069C100.872 16.773 100.276 16.178 99.5406 16.178C98.8052 16.178 98.209 16.773 98.209 17.5069C98.209 18.2409 98.8052 18.8359 99.5406 18.8359Z",
    fill: "#9CB7FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5415 17.947C99.7867 17.947 99.9854 17.7487 99.9854 17.504C99.9854 17.2594 99.7867 17.061 99.5415 17.061C99.2964 17.061 99.0977 17.2594 99.0977 17.504C99.0977 17.7487 99.2964 17.947 99.5415 17.947Z",
    fill: "#2962FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14520_43879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0259 9.00803C20.0259 4.03304 15.9848 0 10.9998 0C6.03655 0 2.02388 3.96252 1.9741 8.91564C1.93652 12.6565 4.18428 15.8775 7.40922 17.2745C7.94887 17.5082 8.41048 17.8909 8.74121 18.3764L10.3562 20.7475C10.665 21.2009 11.3345 21.2009 11.6434 20.7475L13.2583 18.3765C13.588 17.8924 14.0472 17.5094 14.5853 17.2767C17.7864 15.8923 20.0259 12.7114 20.0259 9.00803Z",
    fill: "url(#paint0_linear_14520_43879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 20.6388C10.9479 20.6388 10.8167 20.6248 10.7285 20.4953L9.1136 18.1242C8.73382 17.5666 8.20651 17.1304 7.5887 16.8628C4.41673 15.4888 2.38958 12.3711 2.42427 8.92021C2.44713 6.64385 3.34809 4.5128 4.96117 2.91953C6.57407 1.32644 8.71898 0.448975 11.0002 0.448975H11.0002C15.7292 0.448975 19.5765 4.28863 19.5765 9.00816C19.5765 12.4228 17.5473 15.5068 14.4069 16.8649C13.7926 17.1306 13.2669 17.566 12.8867 18.1242L11.2718 20.4954C11.1836 20.6248 11.0525 20.6388 11.0002 20.6388Z",
    fill: "url(#paint1_linear_14520_43879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 14.6705C14.1335 14.6705 16.6737 12.1353 16.6737 9.00809C16.6737 5.88084 14.1335 3.3457 10.9999 3.3457C7.8664 3.3457 5.32617 5.88084 5.32617 9.00809C5.32617 12.1353 7.8664 14.6705 10.9999 14.6705Z",
    fill: "url(#paint2_linear_14520_43879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7434 11.2508L14.3529 5.87111C13.5143 4.97866 12.3224 4.4209 10.9997 4.4209C8.46118 4.4209 6.40332 6.47464 6.40332 9.00805C6.40332 10.3281 6.96221 11.5176 7.85644 12.3546L13.5374 18.0242C13.8294 17.7056 14.1855 17.4495 14.5853 17.2767C17.1169 16.1818 19.0469 13.963 19.7434 11.2508Z",
    fill: "url(#paint3_linear_14520_43879)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 13.5952C13.5382 13.5952 15.596 11.5415 15.596 9.00805C15.596 6.47463 13.5382 4.4209 10.9997 4.4209C8.46118 4.4209 6.40332 6.47463 6.40332 9.00805C6.40332 11.5415 8.46118 13.5952 10.9997 13.5952Z",
    fill: "url(#paint4_linear_14520_43879)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14520_43879",
    x: 86,
    y: 5.81177,
    width: 26.2764,
    height: 26.2317,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14520_43879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14520_43879",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14520_43879",
    x1: 5.55212,
    y1: 3.57098,
    x2: 23.5257,
    y2: 21.5807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14520_43879",
    x1: 9.06451,
    y1: 7.08138,
    x2: 2.74837,
    y2: 0.752551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14520_43879",
    x1: 14.4211,
    y1: 12.4224,
    x2: 3.12774,
    y2: 1.10636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F92814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14520_43879",
    x1: 16.9024,
    y1: 14.8989,
    x2: 11.897,
    y2: 9.88351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1272D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14520_43879",
    x1: 9.87449,
    y1: 7.29557,
    x2: 12.583,
    y2: 11.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14520_43879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21.9559,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticPdpDeliveryToday);
export default __webpack_public_path__ + "static/media/static_pdp_delivery_today.7dd47bc16a22ae824d4a9916848e307e.svg";
export { ForwardRef as ReactComponent };